(function productGalleryModule(global) {
  'use strict';

  function createExternalPauseMessage(host) {
    if (host === 'youtube') {
      return {
        event: 'command',
        func: 'pauseVideo',
        args: '',
      };
    }

    if (host === 'vimeo') return { method: 'pause' };
    return null;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { createExternalPauseMessage };
  }

  if (!global.document) return;

  const instanceKey = Symbol.for('store-builder.product-gallery');
  const document = global.document;

  if (global[instanceKey]) {
    global[instanceKey].initialize(document);
    return;
  }

  const gallerySelector = '[data-product-gallery]';

  function elementsWithin(root, selector) {
    const elements = [];
    if (root instanceof global.Element && root.matches(selector)) elements.push(root);
    root.querySelectorAll?.(selector).forEach((element) => elements.push(element));
    return elements;
  }

  function pauseMedia(panel) {
    panel.querySelectorAll('video').forEach((video) => video.pause());
    panel.querySelectorAll('model-viewer').forEach((modelViewer) => modelViewer.pause?.());
    panel.querySelectorAll('[data-media-host]').forEach((media) => {
      const message = createExternalPauseMessage(media.dataset.mediaHost);
      const frame = media.querySelector('iframe');
      if (message && frame?.contentWindow) {
        frame.contentWindow.postMessage(JSON.stringify(message), '*');
      }
    });
  }

  function selectMedia(gallery, mediaId) {
    let hasMatch = false;

    gallery.querySelectorAll('[data-product-media-panel]').forEach((panel) => {
      const isActive = panel.dataset.mediaId === String(mediaId);
      panel.hidden = !isActive;
      panel.toggleAttribute('data-media-active', isActive);
      if (!isActive) pauseMedia(panel);
      if (isActive) hasMatch = true;
    });

    gallery.querySelectorAll('[data-product-media-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-current', trigger.dataset.mediaId === String(mediaId) ? 'true' : 'false');
    });

    if (hasMatch) gallery.dataset.activeMediaId = String(mediaId);
  }

  function initializeGallery(gallery) {
    if (gallery.hasAttribute('data-gallery-enhanced')) return;

    const initialMediaId =
      gallery.dataset.initialMediaId || gallery.querySelector('[data-product-media-panel]')?.dataset.mediaId;
    if (!initialMediaId) return;

    gallery.setAttribute('data-gallery-enhanced', '');
    selectMedia(gallery, initialMediaId);
  }

  function initialize(root = document) {
    elementsWithin(root, gallerySelector).forEach(initializeGallery);
  }

  function destroyWithin(root) {
    elementsWithin(root, gallerySelector).forEach((gallery) => {
      gallery.removeAttribute('data-gallery-enhanced');
      gallery.removeAttribute('data-active-media-id');
      gallery.querySelectorAll('[data-product-media-panel]').forEach((panel) => {
        panel.hidden = false;
        pauseMedia(panel);
      });
    });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof global.Element)) return;

    const trigger = event.target.closest('[data-product-media-trigger]');
    const gallery = trigger?.closest(gallerySelector);
    if (!trigger || !gallery || !gallery.hasAttribute('data-gallery-enhanced')) return;

    selectMedia(gallery, trigger.dataset.mediaId);
  });
  document.addEventListener('product:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));

  global[instanceKey] = { initialize, destroyWithin };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})(typeof window !== 'undefined' ? window : globalThis);
